import { HelperResult } from '@openclassrooms/sdk-web';
import { TrainingPlan } from '@openclassrooms/sdk-web/src';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useTrainingPlans } = getCRUDHooks({
  entityName: 'trainingPlans',
  get: ({ userId }): HelperResult<TrainingPlan> =>
    clientApi.getOCClient().helpers.user.users.id(userId).trainingPlans.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useTrainingPlans };
